module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "topbar",
    staticStyle: {
      "z-index": "1000"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "account-sign-status left"
  }, [_vm._v("\n                欢迎来到有木头\n                "), (_vm.username.length === 0) ? [_c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("请登录")]), _c('a', {
    attrs: {
      "href": "/reg"
    }
  }, [_vm._v("免费注册")])] : [_c('a', {
    attrs: {
      "href": "/member/info/"
    }
  }, [_vm._v(_vm._s(_vm.username))])]], 2), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "youmuhead"
  }, [_c('ul', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "so right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入关键词/锯材树种"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchResult($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.searchResult
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topnav right"
  }, [_c('a', {
    attrs: {
      "href": "/member/info/"
    }
  }, [_vm._v("我的有木")]), _vm._v(" "), _c('a', {
    staticClass: "down"
  }, [_vm._v("有木头公众号"), _c('img', {
    attrs: {
      "src": require("../assets/images/code1.jpg")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "down"
  }, [_vm._v("有木头小程序"), _c('img', {
    attrs: {
      "src": require("../assets/logo/xiao_shop.jpg")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/support/software"
    }
  }, [_vm._v("APP下载")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo1.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-eb102ff2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 483
// module chunks = 31